import PropTypes from 'prop-types'

function FormCard({ label, hint, children }) {
  return (
    <section aria-labelledby={label} className="block pt-8">
      <div className="md:grid md:grid-cols-3 md:gap-6">
        <div className="md:col-span-1">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            {label}
          </h3>
          {hint && (
            <p className="mt-1 text-sm text-gray-500">
              {hint}
            </p>
          )}
        </div>
        <div className="mt-5 md:mt-0 md:col-span-2">
          <div className="space-y-6">
            <div className="grid grid-cols-6 gap-6">
              {children}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

FormCard.propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  children: PropTypes.node.isRequired,
}

FormCard.defaultProps = {
  hint: null,
}

export default FormCard
